/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    documentoslist: true,
    documentosadd: false,
    documentos: [],
    documentosListado: [],
    documentosFilter: [],
}